import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { userLoggedIn } from 'store/features/auth/authSlice';

function useAuth() {
	const dispatch = useDispatch();
	const [authCheck, setAuthCheck] = useState(false);

	useEffect(() => {
		const token = localStorage.getItem('token');
		const roleId = localStorage.getItem('roleId');
		const userId = localStorage.getItem('userId');
		const refreshToken = localStorage.getItem('refreshToken');
		const roleName = localStorage.getItem('roleName');

		if (token && roleId && userId) {
			dispatch(
				userLoggedIn({
					accessToken: token,
					roleId: roleId,
					userId: userId,
					refreshToken: refreshToken,
					roleName: roleName,
				})
			);
		}

		setAuthCheck(true);
	}, [dispatch]);

	return authCheck;
}

export default useAuth;
